<!-- Signature usage card skeleton -->
<div class="border border-stroke rounded-lg px-4 py-4.5 flex flex-col gap-6 mb-8">
  <div class="h-6 w-36 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between flex-wrap gap-2">
      <div class="h-8 w-48 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
      <div class="h-4 w-36 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
    <div class="h-3 w-full rounded-full overflow-hidden"><dss-libs-ui-skeleton /></div>
  </div>
</div>
<!-- Addons skeleton -->
<div class="h-72 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
